// Schema completo da ficha de personagem do Cultivo RPG

export interface Atributo {
  nivel: number;
  modificador?: number;
  custoTotal?: number;
}

export interface Atributos {
  FOR: Atributo;
  DES: Atributo;
  CON: Atributo;
  INT: Atributo;
  SAB: Atributo;
  CAR: Atributo;
  POD: Atributo;
}

export interface ValoresDerivados {
  pvMaximos: number;
  pvAtuais: number;
  pqMaximos: number;
  pqAtuais: number;
}

export interface ReinoCultivo {
  nome: string;
  nivel: number;
  multiplicador: number;
  limiteAtributos: number;
  proximoReino: string;
  preparacaoTribulacao: string;
}

export interface RaizEspiritual {
  nome: string;
  nivel: number;
  elemento: string;
  bonus: number;
  custo: number;
}

export interface Tecnica {
  nome: string;
  categoria: string;
  nivel: number;
  custoPQ: number;
  efeito: string;
}

export interface Dominio {
  conceitoDao: string;
  custoAtivacao: number;
  custoPorRodada: number;
  raio: number;
  efeitoEspecial: string;
}

export interface Identidade {
  nome: string;
  sobreposicao: string;
  efeitos: string;
}

export interface Destino {
  nivel: number;
  encontrosSorte: number;
  tribulacoesSubitas: number;
}

export interface FaceHumanidade {
  faceAtual: number;
  humanidade: number;
  efeitos: string;
}

export interface Especializacao {
  nome: string;
  nivel: number;
}

export interface Pericia {
  nome: string;
  atributo: string;
  nivel: number;
  especializacoes: Especializacao[];
}

export interface Vantagem {
  nome: string;
  nivel: number;
  custo: number;
}

export interface Desvantagem {
  nome: string;
  nivel: number;
  ganho: number;
}

export interface Equipamento {
  nome: string;
  tipo: string;
  nivel: number;
  efeitos: string;
}

export interface Item {
  nome: string;
  tipo: string;
  quantidade: number;
  efeitos: string;
}

export interface Experiencia {
  xpAtual: number;
  xpTotalAcumulado: number;
  pontosDisponiveis: number;
}

export interface CharacterSheet {
  // Informações Básicas
  nomePersonagem: string;
  jogador: string;
  dataCriacao: string;
  nivelExperiencia: number;
  reinoAtual: string;

  // Atributos
  atributos: Atributos;
  totalPontosGastosAtributos: number;

  // Valores Derivados
  valoresDerivados: ValoresDerivados;

  // Reino de Cultivo
  reinoCultivo: ReinoCultivo;

  // Raízes Espirituais
  raizesEspirituais: RaizEspiritual[];

  // Técnicas
  tecnicas: Tecnica[];

  // Domínio
  dominio?: Dominio;

  // Identidades
  identidades: Identidade[];
  slotsIdentidades: number;

  // Destino
  destino?: Destino;

  // Face e Humanidade
  faceHumanidade: FaceHumanidade;

  // Perícias
  pericias: Pericia[];

  // Vantagens e Desvantagens
  vantagens: Vantagem[];
  desvantagens: Desvantagem[];

  // Equipamentos
  equipamentos: Equipamento[];

  // Inventário
  inventario: Item[];

  // Experiência
  experiencia: Experiencia;

  // Notas
  notas: string;
}

export const createEmptyCharacterSheet = (): CharacterSheet => ({
  nomePersonagem: "",
  jogador: "",
  dataCriacao: new Date().toLocaleDateString("pt-BR"),
  nivelExperiencia: 0,
  reinoAtual: "",

  atributos: {
    FOR: { nivel: 1 },
    DES: { nivel: 1 },
    CON: { nivel: 1 },
    INT: { nivel: 1 },
    SAB: { nivel: 1 },
    CAR: { nivel: 1 },
    POD: { nivel: 1 },
  },
  totalPontosGastosAtributos: 0,

  valoresDerivados: {
    pvMaximos: 6,
    pvAtuais: 6,
    pqMaximos: 11,
    pqAtuais: 11,
  },

  reinoCultivo: {
    nome: "",
    nivel: 0,
    multiplicador: 1,
    limiteAtributos: 10,
    proximoReino: "",
    preparacaoTribulacao: "",
  },

  raizesEspirituais: [],
  tecnicas: [],
  identidades: [],
  slotsIdentidades: 0,
  faceHumanidade: {
    faceAtual: 0,
    humanidade: 100,
    efeitos: "",
  },

  pericias: [
    { nome: "Combate Corpo a Corpo", atributo: "FOR/DES", nivel: 0, especializacoes: [] },
    { nome: "Combate à Distância", atributo: "DES", nivel: 0, especializacoes: [] },
    { nome: "Combate Desarmado", atributo: "FOR", nivel: 0, especializacoes: [] },
    { nome: "Alquimia", atributo: "INT", nivel: 0, especializacoes: [] },
    { nome: "Matrizes", atributo: "INT", nivel: 0, especializacoes: [] },
    { nome: "Mecânica", atributo: "INT", nivel: 0, especializacoes: [] },
    { nome: "Persuasão", atributo: "CAR", nivel: 0, especializacoes: [] },
    { nome: "Liderança", atributo: "CAR", nivel: 0, especializacoes: [] },
    { nome: "Negociação", atributo: "CAR", nivel: 0, especializacoes: [] },
    { nome: "Meditação", atributo: "SAB", nivel: 0, especializacoes: [] },
    { nome: "Conhecimento Oculto", atributo: "INT", nivel: 0, especializacoes: [] },
    { nome: "Rituais", atributo: "SAB", nivel: 0, especializacoes: [] },
  ],

  vantagens: [],
  desvantagens: [],
  equipamentos: [],
  inventario: [],
  experiencia: {
    xpAtual: 0,
    xpTotalAcumulado: 0,
    pontosDisponiveis: 0,
  },
  notas: "",
});
